<template>
  <div>
    <div class="top">
      <div class="img">
        <img src="../assets/img/logo1.png" alt />
        <p
          class="text-overflow-more text-overflow-more-4"
        >黄钻是彩色钻石的一种，颜色为黄色，产出极为稀少，身价很高。黄钻在世界各地都可以找到。因为其产量极为稀少，颜色鲜艳，深得收藏家青睐。</p>
      </div>
    </div>
    <main>
      <h1>定制流程</h1>
      <hr />
      <p class="desc">
        璀璨的钻石，加上精湛的镶嵌手法
        <br />设计出您专属的钻石戒指、耳环或吊坠
        <br />展露个性特色
      </p>
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <div v-if="index % 2 == 0">
            <video :src="item.video" class="right" controls v-if="item.video"></video>
            <img :src="item.img" class="right" v-else />

            <div>
              <p class="title">{{item.title}}</p>
              <p class="desc" v-html="item.intro"></p>
            </div>
          </div>
          <div v-else>
            <div>
              <p class="title">{{item.title}}</p>
              <p class="desc" v-html="item.intro"></p>
            </div>
            <video :src="item.video" class="left" controls v-if="item.video"></video>
            <img :src="item.img" class="left" v-else />
          </div>
        </li>
      </ul>
      <div class="btn-box">
        <a class="btn" :href="'tel:'+info.custom_tel">
          <i class="el-icon-caret-right"></i>
          定制电话：{{info.custom_tel}}
        </a>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      info: JSON.parse(localStorage.getItem("shop")),
    };
  },
  created() {
    this.axios.post("process/index").then((r) => {
      this.list = [...r];
    });
  },
};
</script>

<style lang="less" scoped>
.top {
  padding: 0.2rem 2.1rem;
  box-sizing: border-box;
  background: #f7f7f7;
  .img {
    width: 100%;
    height: 5rem;
    background: url("../assets/img/shanchu/dingzhi.png") no-repeat;
    background-size: cover;
    padding: 1rem 1.78rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    img {
      width: 2.61rem;
      margin-bottom: 0.41rem;
    }
    p {
      width: 3.8rem;
      font-size: 0.14rem;
      // font-family: "FZShuSong-Z01T";
      color: white;
      font-weight: 100;
   line-height: 24px;
      user-select: none;
    }
  }
}
main {
  padding: 0.4rem 3.6rem;
  box-sizing: border-box;
  h1 {
    margin-bottom: 0.2rem;
  }
  hr {
    width: 0.79rem;
    margin-bottom: 0.16rem;
  }
  .desc {
    text-align: center;
    font-size: 0.18rem;
    // font-family: "FZShuSong-Z01T";
    font-weight: 400;
    line-height: 0.28rem;
  }
}
ul {
  margin-top: 0.6rem;
  li {
    margin-bottom: 0.66rem;
    div {
      display: flex;
      img,
      video {
        width: 7.1rem;
        height: 4.39rem;
      }
      img.right,
      video.right {
        margin-right: 0.69rem;
      }
      img.left,
      video.left {
        margin-left: 0.69rem;
      }
      div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 3.45rem;
        // height: 4.39rem;
        .title {
          font-size: 0.16rem;
          font-family: "FZShuSong-Z01T";
          padding-bottom: 0.15rem;
          border-bottom: 1px solid #00000033;
          margin-bottom: 0.33rem;
        }
        .desc {
          font-size: 0.14rem;
          // font-family: "FZShuSong-Z01T";
          text-align: left;
        }
      }
    }
  }
}
.btn-box {
  text-align: center;
  .btn {
    margin: 0 auto;
    margin-bottom: 0.6rem;
    height: 0.48rem;
    padding: 0 0.4rem;
    box-sizing: border-box;
    background: linear-gradient(
      180deg,
      rgba(153, 125, 70, 1) 0%,
      rgba(188, 156, 96, 1) 100%
    );
    font-size: 0.18rem;
    text-align: center;
    line-height: 0.48rem;
    // font-family: "FZShuSong-Z01T";
    color: white;
    position: relative;
    cursor: pointer;
    user-select: none;
    display: inline-block;
    text-decoration: none;
    i {
      position: absolute;
      left: 0.1rem;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

@media (max-width: 767px) {
  h1 {
    font-size: 20px;
  }

  .top {
    padding: 20px 10px;
    .img {
      height: 200px;
      img {
        width: 100px;
      }
      p {
        font-size: 12px;
        line-height: 20px;
        width: 70%;
        color: rgba(255, 255, 255, 0.78);
      }
    }
  }
  main {
    padding: 20px 10px;
    hr {
      width: 50px;
    }
    .desc {
      font-size: 14px;
      line-height: 20px;
    }
  }
  ul {
    margin-top: 40px;
    li {
      margin-bottom: 20px;
      background: rgb(251, 251, 251);
      div {
        display: block;
        img,
        video {
          width: 100%;
          height: auto;
          margin-left: 0 !important;
        }
        div {
          height: auto;
          width: 100%;
          .title {
            font-size: 16px;
          }
          .desc {
            font-size: 12px;
          }
        }
      }
    }
  }
  .btn-box{

  }
  .btn {
    height: 48px!important ;
    margin: 0!important;
    width: 100%;
    line-height: 48px!important;
    font-size: 14px!important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/customized.vue